import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.$select = this.$('select')[0]
        this.resetUrl = this.getData('reset-url')
        this.queryUrl = this.getData('query-url')

        if (!this.queryUrl || !this.resetUrl) return console.log('Please set reset-url and query-url data')

        this.bindEvents()
    }

    bindEvents() {
        this.onChange = this.onChange.bind(this)
        this.$select.addEventListener('change', this.onChange)
    }

    unbindEvents() {
        this.$select.removeEventListener('change', this.onChange)
    }

    onChange() {
        this.changeRoute()
    }

    changeRoute() {
        let newUrl
        const currentTagHandle = this.$select.value

        if (currentTagHandle) {
            newUrl = this.queryUrl + currentTagHandle
        } else {
            newUrl = this.resetUrl
        }

        window.location.href = newUrl;
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }
}